const EN = {
  "currency-saudi": "SAR",

  // Buttons Labels Repeated
  "modal-ok-btn": "OK",
  "modal-close-btn": "Close",

  // Navbar

  "arabic-key": "Arabic",
  "english-key": "English",
  "urdu-key": "Urdu",
  "hindi-key": "Hindi",
  "main-tab": "Main",
  "laundry-owners-tab": "Laundromats",
  "Delivery-representatives-tab": "Delivery representatives",
  "Accountant-account-tab": "Accounting",
  "Earnings-account-tab": "Earnings account",
  "admin-name": "Admin",
  logout: "Log Out",

  // ==========================================================================================================================================
  // LogIn
  "login-form-header": "Log In",
  "login-password-placeholder": "Password",
  "login-btn-text": "Log In",
  "login-user-name-placeholder": "Username",
  // ==========================================================================================================================================
  // Copy Rights Start
  "copy-rights-start-1": "Have any question?",
  "copy-rights-start-2": "Contact Us",
  "copy-rights-start-3": "Cleaning Services App",
  "copy-rights-start-4": "| All Rights Reserved",
  "copy-rights-start-5": "Developed by Stack Soft Company",

  // ==========================================================================================================================================
  // Main
  "statistics-main-tab": "General Statistics",
  "joins-requests-main-tab": "Join requests",

  // Statistics
  "daily-done-orders-tab": "Daily Done Orders",
  "payed-money-tab": "Payments",
  "most-used-laundry": "Most Used Laundromats",
  "Deliverymen-header": "Deliverymen",
  "Laundromats-header": "Laundromats",
  "Number-of-completed-orders": "Number of Completed Orders",
  "sort-label-statistics":
    "Laundromats from the most to the least applicable (depending on completed orders)",
  "number-of-accepted-orders": "Number of Accepted Orders: ",
  "number-of-done-orders": "Number of Completed Orders: ",
  "number-of-rejected-orders": "Number of Rejected Orders: ",

  // Join Requests
  "delivery-request-tab": "Delivery Requests",
  "Laundry-Owner-request-tab": "Laundromats Owners Requests",
  "accept-request": "Accept",
  "reject-request": "Reject",
  "detail-request-button": "Order details",
  "delivery-person-name": "Deliveryman Name",
  "laundry-name": "Laundromat Name",
  "date-of-request": "Order Date",
  "phone-number": "Phone Number",
  "relative-phone-number": "Relative Phone Number",
  "relative-relation": "Relative Relation",
  nationality: "Nationality",
  "id-or-passport": "ID or Passport",
  address: "City of Residence",
  city: "City",
  "bulding-number": "Bulding Number",
  "floor-number": "Floor Number",
  "vehicle-type": "Vehicle Type",
  "vehicle-color": "Vehicle Color",
  "vehicle-num": "Vehicle Number",
  "vehicle-license": "Vehicle Licence",

  // ==========================================================================================================================================
  // Laundry Owners
  "date-of-join": "Date of join",
  "laund-details-btn": "Laundromat Details",
  "all-laundries-header": "All laundromats joining us:",
  "all-laundromat-tap": "All Laundromats",
  "offers-free-arrive-request-tap": "Free Delivery Orders",
  "offers-free-arrive-accepted-tap": "Acceptable Offers",

  // Laundry Modal
  "laundry-services-label": "Laundromat Services: ",
  "request-service-button": "Service Request",
  "services-laundry-table-column": "Services Provided",
  "size-laundry-table-column": "Serving Size",
  "item-type-column": "Item Type",

  // Filter Laundry
  "Search-box-placeholder": "Search by name or phone number",
  "choose-city": "choose city",
  "date-filter-new-to-old": "From newest to oldest",
  "date-filter-old-to-new": "From oldes to newest",

  // ==========================================================================================================================================
  // All Delivery
  "all-delivery-header": "All delegates joining us:",
  "del-details-btn": "Deliveryman Details",

  // ==========================================================================================================================================
  // Earnings
  "receivables-required": "Required Receivables",
  "commission-due": "Commission Due",
  "the-outcome": "Outcome",
  "outcome-zeroing": "Outcome Zeroing",
  "info-1": "The Weekly Outcomes button only runs on Friday.",
  "info-2":
    "The commission due to the Deliveryman is the total commission due for each service performed by the Deliveryman.",
  "info-3":
    "The receivables required of the Deliveryman are the total taxes that the Deliveryman must pay to the Administrator for each service.",
  "info-4":
    "Outcomes, In case of a positive number, the Deliveryman must pay for the Administrator, or in case of a negative number, the Administrator must pay for the Deliveryman.",
  "info-5":
    'When the outcome is zeroed between the administrator and the deliveryman, the Administrator must zeroing the outcome by pressing the "Outcome Zeroing" button.',
  "Weekly-Outcomes": "Weekly Outcomes",

  // ==========================================================================================================================================
  // Fees
  "label-1-fees":
    "The value of the tax a Deliveryman must pay to the Administrator on each order:",
  "label-2-fees": "Deliveryman's commission for every 1 km:",

  // ==========================================================================================================================================
  // Accountant
  "commissions-and-taxes-tap": "Commissions and Taxes",
  "earnings-calculate-tap": "Earnings Calculate",

  // ==========================================================================================================================================
  // Offers Free Arrive
  "offer-det-btn": "Offer Details",
  "categories-label-offer": "Categories of users covered by the offer:",
  "offer-time-label": "Duration of offer:",
  from: "from:",
  to: "to:",
  "zeroing-cost": "Zeroing",
  cost: "Cost",
};

export default EN;
